<template>
  <v-card :style="backOpacity">
    <v-card-title>カレンダーの設定 CalenderForm.vue</v-card-title>
    {{ rules }}
    <v-card-text>
      <v-container>
        <v-form ref="form" v-model="valid">
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="ラベル名"
                v-model="returnData.label"
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <set-Cols
                :value="String(returnData.cols)"
                v-on:set="$set(returnData, 'cols', $event)"
              ></set-Cols>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[0]"
                label="初期値無し"
                value="true"
              ></v-checkbox>
            </v-col>
            <v-col cols="2">
              <v-checkbox
                v-model="rules[1]"
                label="必須項目"
                value="true"
              ></v-checkbox>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3">
              <v-checkbox
                v-model="form_check"
                label="終了日時の指定"
              ></v-checkbox>
            </v-col>
            <v-col v-if="form_check" cols="4">
              <v-text-field
                label="開始日のフォームID"
                v-model="returnData.value"
                :rules="[varidation.numonly]"
                required
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click.once="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        x-large
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";

export default {
  components: {
    setCols,
  },
  props: {
    //共通値
    type: Number,
    position: Number,
    label: String,
    cols: String,
    //個別値
    rule: String,
    value: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        type: this.type,
        position: this.position,
        cols: this.cols,
        value: this.value,
        rule: this.rule,
      },
      backOpacity: "opacity: 1",
      form_check: false,
      rules: [],
      //バリデーション
      valid: true,
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
      },
    };
  },
  mounted() {
    this.getInit();
  },
  methods: {
    getInit() {
      if (typeof this.rule != "undefined") {
        this.rules = this.rule.split(",");
      }
      if (this.value != null && this.value != "") {
        this.form_check = true;
      }
    },
    submit() {
      if (!this.form_check) {
        this.returnData.value = null;
      }
      this.returnData.rule = this.rules.join(",");
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
